import { css, Theme } from "@emotion/react"

export const buttonStyle = css`
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
`

export const imageRendererStyle = (isSelected: boolean) => css`
	border-radius: 6px;
	border: 1px solid #e5e6e6;
	width: 84px;
	height: 84px;
	padding: 6px;
	box-sizing: border-box;
	${isSelected &&
	css`
		border: 2px solid #0b75e1;
	`}

	@media (max-width: 480px) {
		width: 74px;
		height: 74px;
	}

	svg {
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: center;
	}
`

export const imageStyle = css`
	width: 100%;
	height: 100%;
	object-fit: contain;
	object-position: center;
`

export const showMoreButtonStyle = css`
	border-radius: 6px;
	border: 1px solid #e5e6e6;
	width: 84px;
	height: 84px;
	padding: 6px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	@media (max-width: 480px) {
		width: 74px;
		height: 74px;
	}
`
export const showMoreButtonTextStyle = css`
	background: none;
	border: none;
	cursor: pointer;
	font-size: 2rem;
	font-weight: 600;
	color: #0b75e1;
	width: 74px;
	height: 74px;
	@media (max-width: 480px) {
		font-size: 1.5rem;
	}
`

export const thumbnailContainerStyle = (theme: Theme) => css`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	justify-content: start;
	margin-top: 1.5rem;
	flex-wrap: wrap;
	width: 100%;
	${theme.breakpoints.down("sm")} {
		justify-content: center;
	}
`

export const partImageStyle = (theme: Theme) => css`
	border-radius: 8px;
	border: 1px solid #e5e6e6;
	display: flex;
	height: 384px;
	width: 384px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	padding: 1rem;
	${theme.breakpoints.down("sm")} {
		width: 100%;
	}

	img {
		border-radius: 8px;
	}
`

export const thumbnailGalleryContainerStyle = (theme: Theme) => css`
	max-width: 100px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	max-height: 500px;
	height: 100%;
	overflow-y: auto;
	${theme.breakpoints.down("sm")} {
		max-width: 100%;
		flex-direction: row;
		overflow-x: auto;
		overflow-y: hidden;
		flex-wrap: wrap;
	}
`

export const modalGalleryContainerStyle = css`
	gap: 1rem;
	display: flex;
	flex-direction: column;
	max-height: 895px;
`

export const modalGalleryHeaderStyle = css`
	font-size: 1.5rem;
	font-weight: 700;
`
export const modalGalleryContentStyle = (theme: Theme) => css`
	gap: 1rem;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	justify-content: center;

	${theme.breakpoints.down("sm")} {
		flex-direction: column;
	}
`

export const modalGalleryAssetWrapperStyle = css`
	flex: 1;
	width: 100%;
`

export const modalGalleryAssetStyle = css`
	max-height: 895px;
	width: 100%;
	cursor: initial;

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: center;
	}
`

export const spin360Container = css`
	background: transparent;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	padding: 1rem;
	box-sizing: border-box;
	width: 100%;
	overflow: hidden;
	border: 1px solid #e5e6e6;
	min-height: 384px;
`
